var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"botmbgd"},[_vm._v("\n  用户："+_vm._s(_vm.name)+"\n  "),_c('button',{staticClass:"login-out",on:{"click":_vm.loginOut}},[_vm._v("退出账号")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c130124","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cardinfo/Cardinfo.vue
// module id = null
// module chunks = 